document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".quantity-selector .quantity-selector_card")
    .forEach(function (card) {
      card.addEventListener("click", function () {
        document
          .querySelectorAll(".quantity-selector .quantity-selector_card")
          .forEach(function (item) {
            item.classList.remove("current-qty");
          });
        this.classList.add("current-qty");
      });
    });

  document.querySelectorAll(".flavor_add_qty").forEach(function (element) {
    element.addEventListener("click", function () {
      this.classList.remove("is-active");

      let parentBlock = this.closest(".qty-btn-block");

      if (parentBlock) {
        let quantityContainer = parentBlock.querySelector(
          ".quantity-container"
        );

        if (quantityContainer) {
          quantityContainer.classList.add("is-active");

          let qtyDisplay = quantityContainer.querySelector(
            ".flavor_qty-display"
          );

          // var qty = jQuery(".quantity-selector_card.current-qty").attr("data-qty");
          var qty = "2";
          console.log(qty);

          setTimeout(function () {
            if (qtyDisplay) {
              let vals = qtyDisplay.textContent.trim();
              console.log(vals);

              let sum = 0;
              document
                .querySelectorAll(".quantity-container.is-active")
                .forEach(function (quantityContainer) {
                  var vals = quantityContainer
                    .querySelector(".flavor_qty-display")
                    .textContent.trim();
                  var count = parseInt(vals, 10);
                  if (!isNaN(count)) {
                    sum += count;
                  }
                });

              const select_product = document.querySelector(".select-product");
              const countElement = document.querySelector(
                ".selected-product-count"
              );

              if (sum !== 0) {
                select_product.style.display = "inline";
                countElement.textContent = sum;
                document.querySelector(".select-product.ready-pdp").style.display =
                  "none";
              } else {
                select_product.style.display = "none";
              }
              if (sum == 2) {
                select_product.style.display = "none";
                document.querySelector(".select-product.ready-pdp").style.display =
                  "block";
              }

              console.log("Total Sum:", sum); // Log the total sum
              if (qty == sum) {
                console.log("match");
                document
                  .querySelectorAll(".product-btn")
                  .forEach(function (btn) {
                    btn.removeAttribute("disabled");
                  });
                document
                  .querySelectorAll(
                    ".button-text, .flavor_qty-button.qty-plus, .flavor_add_qty.flavor_add-btn"
                  )
                  .forEach(function (disabled_btn) {
                    disabled_btn.classList.add("disabled");
                  });
              } else {
                console.log("not match");
                document
                  .querySelectorAll(".product-btn")
                  .forEach(function (btn) {
                    btn.setAttribute("disabled", "true");
                  });
                document
                  .querySelectorAll(
                    ".button-text, .flavor_qty-button.qty-plus, .flavor_add_qty.flavor_add-btn"
                  )
                  .forEach(function (disabled_btn) {
                    disabled_btn.classList.remove("disabled");
                  });
              }
            }
          }, 200);
        }
      }
    });
  });

  /*  onload price change */
  function price_change() {
    var price =
      parseFloat(
        jQuery(".quantity-selector_card.current-qty").attr("data-price")
      ) || 0;
    console.log("Price uu:", price);

    // var qty = parseInt(jQuery(".quantity-selector_card.current-qty").attr("data-qty")) || 0;
    var qty = parseInt("2") || 0;
    console.log("Quantity:", qty);

    var total = price * qty;
    console.log("Total:", total);
    jQuery(".product-btn-block .atc-price").text(total);
    jQuery(".product-btn-block .atc-compare-price").text("");

    // jQuery("#price-main-product-onetime .pdp-price").text("$" + total);
    var newPrice = total - 3.99;
    jQuery("#price-main-product-onetime .pdp-price").text("$" + newPrice.toFixed(2));
    // jQuery(".sticky-add-cart .price-discount-block .product-price-block").text(
    //   "$" + total
    // );
    jQuery(".sticky-add-cart .price-discount-block .product-price-block").text(
      "$" + newPrice.toFixed(2)
    );

    jQuery("#price-main-product-onetime .pack-price").text(
      "(" + price + "/pack)"
    );
    jQuery(".sticky-add-cart .price-discount-block .pack-price").text(
      "(" + price + "/pack)"
    );

    jQuery(".product-subscription-label").hide();
    jQuery(".pack-price-saving").hide();
    jQuery(".product-static-subcontent").hide();
  }
  price_change();
  /* End onload price change */

  jQuery(".quantity-selector .quantity-selector_card").click(function () {
    var vals = jQuery(this).attr("data-qty");
    console.log(vals);

    var totalQty = 0;
    jQuery(".main-product-block").each(function () {
      jQuery(this)
        .find(".quantity-container.is-active .flavor_qty-display")
        .each(function () {
          var qty = parseInt(jQuery(this).text(), 10) || 0; // Convert text to number safely
          totalQty += qty;
        });
    });

    console.log("Total Quantity:", totalQty);

    if (vals == totalQty) {
      console.log("yes");
      document.querySelectorAll(".product-btn").forEach(function (btn) {
        btn.removeAttribute("disabled");
      });
      document
        .querySelectorAll(
          ".button-text, .flavor_qty-button.qty-plus, .flavor_add_qty.flavor_add-btn"
        )
        .forEach(function (disabled_btn) {
          disabled_btn.classList.add("disabled");
        });
    } else {
      console.log("no");
      document.querySelectorAll(".product-btn").forEach(function (btn) {
        btn.setAttribute("disabled", "true");
      });
      document
        .querySelectorAll(
          ".button-text, .flavor_qty-button.qty-plus, .flavor_add_qty.flavor_add-btn"
        )
        .forEach(function (disabled_btn) {
          disabled_btn.classList.remove("disabled");
        });
    }

    price_change();

    /* End qty code */
  });

  document
    .querySelectorAll(".flavor_add_qty.qty-minus")
    .forEach(function (element) {
      element.addEventListener("click", function () {
        let quantityContainer = this.closest(".quantity-container");

        if (quantityContainer) {
          let qtyDisplay = quantityContainer.querySelector(
            ".flavor_qty-display"
          );

          if (qtyDisplay) {
            let length = parseInt(qtyDisplay.textContent.trim(), 10); // Convert text to number
            console.log(length);

            if (length <= 1) {
              console.log("yes");
              jQuery(this)
                .parents(".quantity-container")
                .removeClass("is-active");
              jQuery(this)
                .parents(".qty-btn-block")
                .find(".flavor_add-btn")
                .addClass("is-active");
            }
          }
        }
      });
    });

  document
    .querySelectorAll(".quantity-container")
    .forEach(function (container) {
      let qtyDisplay = container.querySelector(".flavor_qty-display");
      console.log(qtyDisplay);
      container
        .querySelector(".qty-plus")
        .addEventListener("click", function () {
          let currentQty = parseInt(qtyDisplay.textContent, 10);
          qtyDisplay.textContent = currentQty + 1;
        });

      container
        .querySelector(".qty-minus")
        .addEventListener("click", function () {
          let currentQty = parseInt(qtyDisplay.textContent, 10);
          if (currentQty > 1) {
            qtyDisplay.textContent = currentQty - 1;
          }
        });
    });

  document.querySelectorAll(".product-btn").forEach(function (button) {
    button.addEventListener("click", function () {
      document
        .querySelectorAll(".main-product-block")
        .forEach(function (mainBlock) {
          mainBlock
            .querySelectorAll(".quantity-container.is-active")
            .forEach(function (container) {
              let inputElement = container.querySelector('input[name="id"]');
              if (inputElement) {
                let vals = inputElement.value;
                console.log(vals);
              }
            });
        });
    });
  });
});

jQuery(document).ready(function () {
  jQuery(
    ".form-purchase-type-wrapper .form-purchase-type .purchase-type-input"
  ).click(function () {
    var vals = jQuery(this).val();
    console.log(vals);

    jQuery(".main-subscription-block .form-purchase-type").removeClass(
      "active"
    );
    jQuery(this).parents(".form-purchase-type").addClass("active");

    if (vals !== "purchase-type-onetime") {
      console.log("yessss");
      console.log("yes" + "aa");
      var data_val = jQuery(".subscribe-free-block")
        .find('input[name="id"]')
        .val();
      console.log(data_val);

      jQuery('.product-btn-block input[name="selling_plan"]').val(5122752672);
      sellingPlan = jQuery(this).data("selling-plan") || null;

      var default_subprice = parseFloat(
        jQuery(".form-purchase-type.subsciption-part")
          .find(".price-block-one-time .product-subscription-price")
          .text()
          .replace("$", "")
          .trim()
      );
      var price_per_pack = (
        Math.floor((default_subprice / 30) * 100) / 100
      ).toFixed(2);

      jQuery(".product .product-price-litter").text(
        "($" + price_per_pack + "/latte)"
      );
      jQuery(".sticky-add-cart .price-discount-block .pack-price").text(
        "($" + price_per_pack + "/latte)"
      );

      var price = jQuery(".form-purchase-type.subsciption-part")
        .find(".price-block-one-time .product-subscription-price")
        .text()
        .replace("$", "")
        .trim();
      console.log("Price gg:", price);
      var selected_qty = "2";
      console.log("Quantity:", selected_qty);

      // var total_price = parseFloat(price) * parseInt(selected_qty, 10);
      var total_price = parseFloat(price);
      console.log("Total Price:", total_price);
      jQuery(".product-btn-block .atc-price").text(total_price);

      jQuery(".product #price-main-product-onetime .pdp-price").text(
        "$" + total_price
      );
      jQuery(
        ".sticky-add-cart .price-discount-block .product-price-block"
      ).text("$" + total_price);

      var compare_price = jQuery(".form-purchase-type.subsciption-part")
        .find(".price-block-one-time .subscription-compareprice")
        .text()
        .replace("$", "")
        .trim();

      // var total_comprice = parseFloat(compare_price) * parseInt(selected_qty, 10);
      var total_comprice = parseFloat(compare_price);
      console.log("Total Compare Price:", total_comprice);
      // jQuery(".product-btn-block .atc-compare-price").text(total_comprice);
      jQuery(".product-btn-block .atc-compare-price").text("$104.99");

      jQuery(".product #price-main-product-onetime .pdp-compare-price").text(
        // "$" + total_comprice
        "$104.99"
      );
      // jQuery(
      //   ".sticky-add-cart .price-discount-block .product-compareprice-block"
      // ).text("$" + total_comprice);
      jQuery(
        ".sticky-add-cart .price-discount-block .product-compareprice-block"
      ).text("$104.99");

      jQuery(".pack-price-saving").show();
      jQuery(".product-subscription-label").show();
      jQuery(".product-static-subcontent").show();
      jQuery(".benefit_details_1 h4").text("Under 90 Calories*");
      jQuery(".benefit_details_3 h4").text("Only $1.59/latte");
    } else {
      console.log("noooooo");
      jQuery('.product-btn-block input[name="selling_plan"]').val("");
      var sele_val = jQuery(".quantity-selector_card.current-qty").attr(
        "data-price"
      );
      console.log(sele_val);
      // var sele_qty = jQuery(".quantity-selector_card.current-qty").attr("data-qty");
      var sele_qty = "2";
      console.log(sele_qty);
      var total = sele_val * sele_qty;
      console.log("Total:", total);
      jQuery(".product-btn-block .atc-price").text(total);
      jQuery(".product-btn-block .atc-compare-price").text("");

      // jQuery("#price-main-product-onetime .pdp-price").text("$" + total);
      // jQuery(".sticky-add-cart .product-price-block").text("$" + total);
      var newPrice = total - 3.99;
      jQuery("#price-main-product-onetime .pdp-price").text("$" + newPrice.toFixed(2));
      jQuery(".sticky-add-cart .product-price-block").text("$" + newPrice.toFixed(2));

      var compare_price = jQuery(
        ".main-subscription-block .onetime-compare-price"
      ).text();
      jQuery("#price-main-product-onetime .pdp-compare-price").text(
        compare_price
      );
      jQuery(".sticky-add-cart .product-compareprice-block").text(
        compare_price
      );

      // var prices_pack = jQuery(".quantity-selector_card.current-qty").attr("data-price");
      var prices_pack = parseFloat(
        jQuery(".form-purchase-type-price-onetime")
          .text()
          .replace("$", "")
          .trim()
      );
      var price_per_pack = (Math.floor((prices_pack / 30) * 100) / 100).toFixed(
        2
      );

      jQuery(".product .product-price-litter").text(
        "($" + price_per_pack + "/pack)"
      );
      jQuery(".sticky-add-cart .price-discount-block .pack-price").text(
        "($" + price_per_pack + "/pack)"
      );

      jQuery(".product-subscription-label").hide();
      jQuery(".pack-price-saving").hide();
      jQuery(".product-static-subcontent").hide();
      jQuery(".benefit_details_1 h4").text("Under 100 Calories");
      jQuery(".benefit_details_3 h4").text("Only $1.99/latte");
    }
  });

  jQuery(".product-btn").click(function (e) {
    e.preventDefault();

    var items = [];
    var $btnBlock = jQuery(this).closest(".product-btn-block");

    var data_qty = jQuery(
      ".form-purchase-type-wrapper .form-purchase-type .purchase-type-input:checked"
    ).val();
    console.log("Selected Purchase Type:", data_qty);
    if (data_qty === "purchase-type-recurring") {
      var items = [];

      jQuery(".subscribe-free-block .main-product-info").each(function () {
        var recurringVariantId = jQuery(this).find('input[name="id"]').val();
        console.log("Recurring Variant ID:", recurringVariantId);

        if (recurringVariantId) {
          items.push({
            id: recurringVariantId,
            quantity: 1,
          });
        }
      });
    }

    var productId = $btnBlock.find('input[name="id"]').val();
    var qty = 1;
    var purchaseType = $btnBlock.find(".purchase-type-input:checked").val();
    var sellingPlan =
      purchaseType === "purchase-type-onetime"
        ? ""
        : $btnBlock.find('input[name="selling_plan"]').val();

    if (productId) {
      items.push({
        id: productId,
        quantity: qty,
        selling_plan: sellingPlan ? sellingPlan : null, // Add selling plan if available
      });
    }

    jQuery(".main-product-block").each(function () {
      jQuery(this)
        .find(".quantity-container.is-active")
        .each(function () {
          var additionalProductId = jQuery(this).find('input[name="id"]').val();
          var additionalQuantity = parseInt(
            jQuery(this).find(".flavor_qty-display").text().trim(),
            10
          );
          var sellingPlan =
            purchaseType === "purchase-type-onetime"
              ? ""
              : $btnBlock.find('input[name="selling_plan"]').val();

          if (additionalProductId && additionalQuantity > 0) {
            items.push({
              id: additionalProductId,
              quantity: additionalQuantity,
              selling_plan: sellingPlan ? sellingPlan : null,
            });
          }
        });
    });

    if (items.length > 0) {
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: JSON.stringify({ items: items }),
        dataType: "json",
        contentType: "application/json",
        success: function (response) {
          console.log("Products added to cart successfully:", response);
          jQuery.getJSON("/cart.js", function (cart) {
            let currentItemCount = cart.item_count;
            console.log(currentItemCount + "data");
            jQuery(".header-cart .cart-total-items").text(currentItemCount);
          });

          jQuery(".rebuy-cart__flyout-item-remove").click(function () {
            jQuery.getJSON("/cart.js", function (cart) {
              let currentItemCount = cart.item_count;
              console.log(currentItemCount + "data");
              jQuery(".header-cart .cart-total-items").text(currentItemCount);
            });
          });
        },
        error: function (xhr, status, error) {
          console.error("Failed to add products to cart:", error);
        },
      });
    } else {
      console.log("No valid products selected.");
    }

    console.log("Final Product Data Array:", items);
  });

  jQuery(".sticky-add-to-cart").click(function () {
    jQuery("html, body").animate(
      {
        scrollTop: jQuery("#MainProduct-main-product-onetime").offset().top,
      },
      1000
    );
  });
});

window.addEventListener("scroll", function () {
  var buttons = document.querySelectorAll("#MainProduct-main-product-onetime");

  buttons.forEach(function (button) {
    var rect = button.getBoundingClientRect();

    if (rect.top > window.innerHeight || rect.bottom < 0) {
      console.log("yes");
      jQuery(".sticky-add-cart").addClass("active");
    } else {
      console.log("no");
      jQuery(".sticky-add-cart").removeClass("active");
    }
  });
});



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.main-product-block').forEach(block => {
    block.addEventListener('click', () => {
      const classList = Array.from(block.classList);
      const productClass = classList.find(cls =>
        ['oat-lavender-matcha-latte', 'toasted-vanilla-matcha-latte', 'shaken-brown-sugar-latte', 'salted-caramel-latte'].includes(cls)
      );
      if (!productClass) return;
      document.querySelectorAll('.whole-separate-ingredients-content').forEach(content => {
        content.classList.add('hidden');
      });
      const targetContent = document.querySelector(`.whole-separate-ingredients-content.${productClass}`);
      if (targetContent) {
        targetContent.classList.remove('hidden');
      }
    });
  });
});